import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil, take } from 'rxjs/operators';
import { CallComponent } from "../call/call.component";
import { Subject } from 'rxjs';
import { DeskStateService } from '../../services/desk-state.service';
import { ChatService } from '../../services/chat.service';
import { BusinessEventService } from '../../services/business-event.service';
var StopdeskComponent = (function () {
    function StopdeskComponent(_data, _deskState, _bevent, _chat, _blogic) {
        this._data = _data;
        this._deskState = _deskState;
        this._bevent = _bevent;
        this._chat = _chat;
        this._blogic = _blogic;
        this.loadingSocket = false;
        this.inline = false;
        this.destroy$ = new Subject();
    }
    StopdeskComponent.prototype.ngOnInit = function () {
        this._loadDeskState();
    };
    StopdeskComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    StopdeskComponent.prototype.stop = function () {
        this._bevent.close();
        this._chat.close();
        this._data.deskStopped = true;
        this._saveDeskState();
        this._blogic
            .stop()
            .pipe(take(1))
            .subscribe();
    };
    StopdeskComponent.prototype.ready = function () {
        this.InitSocketCom();
        this._data.deskStopped = false;
        this._saveDeskState();
        this._blogic
            .ready()
            .pipe(take(1))
            .subscribe();
    };
    StopdeskComponent.prototype.InitSocketCom = function () {
        var _this = this;
        if (!this.loadingSocket) {
            this.loadingSocket = true;
            if (this.subscriptionClose != null)
                this.subscriptionClose.unsubscribe();
            if (this.subscriptionOpen != null)
                this.subscriptionOpen.unsubscribe();
            this._bevent.close();
            this._bevent.open();
            this.subscriptionOpen = this._bevent.onOpen()
                .pipe(takeUntil(this.destroy$))
                .subscribe(function () {
                _this.loadingSocket = false;
            });
            this.subscriptionClose = this._bevent.onClose()
                .pipe(takeUntil(this.destroy$))
                .subscribe();
        }
    };
    StopdeskComponent.prototype._saveDeskState = function () {
        var state = {
            deskStopped: this._data.deskStopped,
        };
        this._deskState.saveState(state);
    };
    StopdeskComponent.prototype._loadDeskState = function () {
        var savedState = this._deskState.loadState();
        if (savedState) {
            this._data.deskStopped = savedState.deskStopped || false;
        }
    };
    return StopdeskComponent;
}());
export { StopdeskComponent };
